import React from 'react'
import { CaptionLight } from '../../../components'

export const AllGroupsTableHead = () => (
  <thead>
    <tr>
      <th />
      <th>
        <CaptionLight>Group Capabilities</CaptionLight>
      </th>
      <th>
        <CaptionLight>Managers</CaptionLight>
      </th>
      <th>
        <CaptionLight>Last edited</CaptionLight>
      </th>
      <th>
        <CaptionLight>Last activity</CaptionLight>
      </th>
    </tr>
  </thead>
)
